/* eslint-disable no-param-reassign */
import axios from 'axios';
import notice from './notice';

// create the http object
const http = axios.create({
  baseURL: `${process.env.VUE_APP_API_HOST}`,
  crossDomain: true,
  timeout: 20000,
});

http.interceptors.response.use(response => response, (err) => {
  notice.fireError(err.response.data.message || 'An error has occured.');
  return Promise.reject(err);
});

export default {
  get(url, options) {
    return http.get(url, options);
  },
  post(url, body) {
    return http.post(url, body);
  },
  put(url, body) {
    return http.put(url, body);
  },
  delete(url) {
    return http.delete(url);
  },
};
